// 1. 引入对应模块
import Vue from 'vue'
import VueRouter from 'vue-router'

const Home = () => import('./../pages/Home/Home');
const Course = () => import('./../pages/Course/Index')
const ProCourse = () => import('./../pages/Course/ProCourse')
const CourseItem = () => import('./../pages/Course/CourseItem')
const Program = () => import('./../pages/Program/Program')
const About = () => import('./../pages/Promotion/Promotion')
const Transfer = () => import('./../pages/Transfer/Transfer')
const Toapply = () => import('../pages/Toapply/Toapply')
const Document = () => import('./../pages/Document/Document')
const Contact = () => import('./../pages/Contact/Contact')
const Faq = () => import('./../pages/Faq/Faq')
const Blog = () => import('./../pages/Blog/Blog')
const BlogDetail = () => import('./../pages/Blog/BlogDetail')
const Activity = () => import('./../pages/Activity/Activity')
const ProgramItem = () => import('./../pages/Program/ProgramItem')
const Login = () => import('./../pages/Login/Login')
const Reg = () => import('./../pages/Login/Reg')
const Forget = () => import('./../pages/Login/Forget')

const Pay = () => import('./../pages/Order/Pay')

const IndexAct = () => import('./../pages/H5Activity/Index')
const ThingsAct = () => import('./../pages/H5Activity/studyAbroadThings')
const Search = () => import('./../pages/Search/Search');
const Goods = () => import('./../pages/Goods/Goods');
const ShopCar = () => import('./../pages/ShopCar/ShopCar');
const AdminLogin = () => import('./../pages/AdminLogin/AdminLogin');
const Admin = () => import('./../pages/Admin/Admin');
const SearchDetail = () => import('./../pages/SearchDetail/SearchDetail');
const Order = () => import('./../pages/Order/Order');
const Share = () => import('./../pages/Share/Share');

const AdminSales = () => import('./../pages/Admin/Children/AdminSales');
const AddGoods = () => import('./../pages/Admin/Children/AddGoods');
const AdminGoods = () => import('./../pages/Admin/Children/AdminGoods');
const AdminUpdate = () => import('./../pages/Admin/Children/AdminUpdate');
const AdminUsers = () => import('./../pages/Admin/Children/AdminUsers');

// 2. 声明使用
Vue.use(VueRouter);

// 3. 输出路由对象
export default new VueRouter({
  mode:'history',
  // 3.1 配置一级路由
  routes: [
    {
      path: '/share',
      component: Share,
      meta: { showHeaderTop: false, showFooter: false, showChatFooter: false}
    },
    {
      path: '/activity/draw',
      component: IndexAct,
      meta: { showHeaderTop: false, showFooter: false, showChatFooter: false}
    },
    {
      path: '/activity/things',
      component: ThingsAct,
      meta: { showHeaderTop: false, showFooter: false, showChatFooter: false}
    },
    {
      path: '/pay',
      component: Pay,
      meta: { showHeaderTop: true, showFooter: false, showChatFooter: false}
    },
    {
      path: '/login',
      component: Login,
      meta: { showHeaderTop: true, showFooter: true, showChatFooter: true}
    },
    {
      path: '/reg',
      component: Reg,
      meta: { showHeaderTop: true, showFooter: true, showChatFooter: true}
    },
    {
      path: '/forget',
      component: Forget,
      meta: { showHeaderTop: true, showFooter: true, showChatFooter: true}
    },
    {
      path: '/home',
      component: Home,
      meta: { showHeaderTop: true, showFooter: true, title: "Access Online Courses from Top Schools and Earn College Credits" },
    },
    {
      path: '/course',
      component: Course,
      meta: { showHeaderTop: true, showFooter: true, showChatFooter: true, showFaqFooter: true , title: "Take College Courses Online For Credit"}
    },
    {
      path: '/procourse',
      component: ProCourse,
      meta: { showHeaderTop: true, showFooter: true, showChatFooter: true, showFaqFooter: true , title: "Take College Courses Online For Credit"}
    },
    {
      path: '/courseDetail',
      component: CourseItem,
      meta: { showHeaderTop: true, showFooter: true, showChatFooter: true, title: "LightCourse - CourseDetail"}
    },
    {
      path: '/program',
      component: Program,
      meta: { showHeaderTop: true, showFooter: true, showChatFooter: true, title: "International Credit-Bearing Summer Programs"}
    },
    {
      path: '/programItem',
      component: ProgramItem,
      meta: { showHeaderTop: true, showFooter: true, showChatFooter: true}
    },
    {
      path: '/about',
      component: About,
      meta: { showHeaderTop: true, showFooter: true, showChatFooter: true, showFaqFooter: true, title: "International Credit-Bearing Summer Programs"}
    },
    {
      path: '/transfer',
      component: Transfer,
      meta: { showHeaderTop: true, showFooter: true, showChatFooter: true, showFaqFooter: true, title: "LightCourse-如何转学分" }
    },
    {
      path: '/document',
      component: Document,
      meta: { showHeaderTop: true, showFooter: true, showChatFooter: true, showFaqFooter: true }
    },
    {
      path: '/toapply',
      component: Toapply,
      meta: { showHeaderTop: true, showFooter: true, showChatFooter: true, showFaqFooter: true }
    },
    {
      path: '/contact',
      component: Contact,
      meta: { showHeaderTop: true, showFooter: true, showChatFooter: true, showFaqFooter: true }
    },
    {
      path: '/faq',
      component: Faq,
      meta: { showHeaderTop: true, showFooter: true, showChatFooter: true}
    },
    {
      path: '/blog',
      component: Blog,
      meta: { showHeaderTop: true, showFooter: true, showChatFooter: true}
    },
    {
      path: '/blogDetail',
      component: BlogDetail,
      meta: { showHeaderTop: true, showFooter: true, showChatFooter: true}
    },
    {
      path: '/activity',
      component: Activity,
      meta: { showHeaderTop: true, showFooter: true, showChatFooter: true}
    },
    {
      path: '/search/:id/:pageNo',
      component: Search,
      meta: { showHeaderTop: true, showHeaderSearch: true }
    },
    {
      path: '/goods/:id',
      component: Goods,
      meta: { showHeaderTop: true }
    },
    {
      path: '/shopcar',
      component: ShopCar,
      meta: { showHeaderTop: true }
    },
    {
      path: '/adminlogin',
      component: AdminLogin
    },
    {
      path: '/admin',
      component: Admin,
      children: [
        { path: 'adminsales', component: AdminSales },
        { path: 'adminusers', component: AdminUsers },
        { path: 'addgoods', component: AddGoods },
        { path: 'admingoods', component: AdminGoods },
        { path: 'adminupdate', component: AdminUpdate },
        { path: '/admin', redirect: '/admin/admingoods' }
      ],
    },
    {
      path: '/searchdetail',
      component: SearchDetail,
      meta: { showHeaderTop: true, showHeaderSearch: true }
    },
    {
      path: '/order',
      component: Order
    },
    {
      path: '/',
      redirect: '/home'
    },
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js